import { GridContainer, GridItem, GridRow } from "@tvg/fuse/grid";
import { SpacingWrapper } from "@tvg/fuse/spacing-wrapper";
import { TextBlock as FuseTextBlock } from "@tvg/fuse/text-block";
import useRender from "client/hooks/useRender";
import React from "react";
import { AmpTextBlock } from "types/amplience";
import { backgroundConfig } from "./config";

export interface TextBlockProps {
  config: AmpTextBlock;
  gridWrapper?: boolean;
  noSidePadding?: boolean;
}

export const TextBlock: React.FC<TextBlockProps> = ({ config, gridWrapper = true, noSidePadding = false }) => {
  const render = useRender();

  const textHTML = { __html: render(config.text, config.background) };

  return gridWrapper ? (
    <SpacingWrapper marginBottom="l">
      <GridContainer>
        <GridRow>
          <GridItem xxs={12} l={8} colStart-l={3}>
            <FuseTextBlock
              background={config.background && backgroundConfig[config.background].propValue}
              blackBorder={config.blackBorder}
              dataTestId="content-text-block"
              disablePaddingLeft={noSidePadding}
              disablePaddingRight={noSidePadding}
            >
              <div dangerouslySetInnerHTML={textHTML} />
            </FuseTextBlock>
          </GridItem>
        </GridRow>
      </GridContainer>
    </SpacingWrapper>
  ) : (
    <FuseTextBlock
      background={config.background && backgroundConfig[config.background].propValue}
      blackBorder={config.blackBorder}
      dataTestId="content-text-block"
      disablePaddingLeft={noSidePadding}
      disablePaddingRight={noSidePadding}
    >
      <div dangerouslySetInnerHTML={textHTML} />
    </FuseTextBlock>
  );
};
